export default __webpack_public_path__ + "static/everlywell360-be46ba1ab9c50b7ca91353e72b68f2d6.png";